import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { StoreProvider } from './Utils/Store';
import { Provider } from 'react-redux';
import { store } from './store';
import { LanguageProvider } from './context/LanguageContext';

// Ignore noisy browser ResizeObserver warnings in dev overlay.
if (typeof window !== 'undefined') {
  const resizeObserverRegex =
    /ResizeObserver loop completed with undelivered notifications\.|ResizeObserver loop limit exceeded/i;

  const isResizeObserverNoise = (msg) => resizeObserverRegex.test(String(msg || ''));

  // Catch-phase handler to block React dev overlay from picking it up.
  window.addEventListener(
    'error',
    (event) => {
      if (isResizeObserverNoise(event?.message)) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    },
    true
  );

  const previousOnError = window.onerror;
  window.onerror = function onWindowError(message, source, lineno, colno, error) {
    if (isResizeObserverNoise(message)) {
      return true;
    }

    if (typeof previousOnError === 'function') {
      return previousOnError(message, source, lineno, colno, error);
    }

    return false;
  };

  window.addEventListener('unhandledrejection', (event) => {
    const reason = event?.reason;
    const reasonMessage = typeof reason === 'string' ? reason : reason?.message;
    if (isResizeObserverNoise(reasonMessage)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  });

  const originalConsoleError = console.error;
  console.error = (...args) => {
    const first = args?.[0];
    if (isResizeObserverNoise(first)) return;
    originalConsoleError(...args);
  };
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <LanguageProvider>
      <StoreProvider>
        <App />
      </StoreProvider>
    </LanguageProvider>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
